module.exports = "/_next/static/images/aetna-card-b0cde966312140d437c3084096ecdc2a.png";